<!-- Password Recovery Page -->
<main class="recovery-main">

  <section class="recovery-section">
    <div class="recovery-content">

      <div class="recovery-heading">
        <div class="recovery-heading-icon"><i class="fas fa-unlock-alt"></i></div>
        <div>
          <h1 class="recovery-title">{{ 'RECOVERY.TITLE' | translate }}</h1>
          <p class="recovery-subtitle">{{ 'RECOVERY.INSTRUCTIONS' | translate }}</p>
        </div>
      </div>

      <form [formGroup]="recoveryForm" (ngSubmit)="onSubmit()" class="recovery-card">

        <!-- Success message -->
        <div *ngIf="emailSent" class="recovery-alert recovery-alert--success">
          <i class="fa-solid fa-check-circle"></i>
          {{ 'RECOVERY.SUCCESS_MESSAGE' | translate }}
        </div>

        <!-- General error -->
        <div *ngIf="hasGeneralError()" class="recovery-alert recovery-alert--error">
          <i class="fa-solid fa-exclamation-circle"></i>
          {{ getGeneralError() | translate }}
        </div>

        <!-- Rate limit warning -->
        <div *ngIf="rateLimited" class="recovery-alert recovery-alert--warning">
          <i class="fa-solid fa-clock"></i>
          {{ 'RECOVERY.RATE_LIMIT_WARNING' | translate }}
        </div>

        <label class="recovery-label" for="email">{{ 'RECOVERY.EMAIL_LABEL' | translate }}</label>
        <div class="recovery-input-wrapper" [class.is-invalid]="hasError('email')">
          <i class="fas fa-envelope recovery-input-icon"></i>
          <input
            id="email"
            type="email"
            formControlName="email"
            class="recovery-input"
            [placeholder]="'RECOVERY.EMAIL_PLACEHOLDER' | translate"
            autocomplete="email"
          />
        </div>
        <div *ngIf="hasError('email')" class="recovery-error">
          <i class="fas fa-exclamation-circle"></i>
          {{ getErrorMessage('email') | translate }}
        </div>

        <button type="submit" class="recovery-btn" [disabled]="isLoading || emailSent">
          <ng-container *ngIf="!isLoading">
            <i class="fa-solid fa-envelope"></i>
            {{ 'RECOVERY.SUBMIT' | translate }}
          </ng-container>
          <ng-container *ngIf="isLoading">
            <i class="fa-solid fa-envelope-open-text recovery-btn-animation"></i>
            {{ 'RECOVERY.SENDING' | translate }}
          </ng-container>
        </button>

        <div class="recovery-footer">
          <a routerLink="/login">
            <i class="fa-solid fa-arrow-left"></i>
            {{ 'RECOVERY.BACK_TO_LOGIN' | translate }}
          </a>
        </div>
      </form>

      <p class="recovery-hint">
        <i class="fas fa-info-circle"></i>
        Se non ricevi l'email entro qualche minuto, controlla anche la cartella spam.
      </p>

    </div>
  </section>

</main>
